export default "__VITE_ASSET__056024b4__"